import script from "./Siding14Extras.vue?vue&type=script&setup=true&lang=js"
export * from "./Siding14Extras.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__